


























import { Component, Vue } from "vue-property-decorator"
import store from "./../store"
import router from "@/router"
import { cacheSrv } from "./../services/cache"
import { systemSrv } from "./../services/system"
import axios from "axios"

@Component({
  components: {},
})
export default class Logout extends Vue {
  CACHE_KEY_PROFILE = this.$store.getters.tokenKeys.CACHE_KEY_PROFILE;
  CACHE_KEY_TOKEN = this.$store.getters.tokenKeys.CACHE_KEY_TOKEN;
  loggedout = false;
  processing = false
  constructor() {
    super();
  }
  created() {
    let token = cacheSrv.cached(this.CACHE_KEY_TOKEN);
    if (!token) {
      this.loggedout = true;
    }
  }
  login() {
    router.push("login");
  }
  cancel(){
    router.push("dashboard");
  }
  logout() {
    this.processing = true
    cacheSrv.remove(this.CACHE_KEY_PROFILE);
    cacheSrv.remove(this.CACHE_KEY_TOKEN);
    cacheSrv.remove("answers");
    store.commit(`logout`);
    router.push("login");
    this.processing = false
    this.loggedout = true;
  }
}
